"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getS3Url = exports.getS3Arn = void 0;
const getS3Arn = (bucketName) => `arn:aws:s3:::${bucketName}`;
exports.getS3Arn = getS3Arn;
const getS3Url = (bucketName) => `s3://${bucketName}`;
exports.getS3Url = getS3Url;
